import { render, staticRenderFns } from "./ShoppingCartDelete.vue?vue&type=template&id=976015b8"
import script from "./ShoppingCartDelete.vue?vue&type=script&lang=js"
export * from "./ShoppingCartDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports